<div class="header">
  <div class="logo">
    <img src="assets/aida-logo.png" alt="AIDA Logo" />
  </div>

  <div class="header-content">
    <div class="page-title">
      <dx-text type="pb" id="branding-page-title">{{ "header.page-title" | transloco }}</dx-text>
    </div>
    <div class="user-logout">
      <dx-text type="ps" class="user-name">{{ userName() }}</dx-text>
      <art-button
        shape="link"
        label="{{ 'header.button.logout' | transloco }}"
        icon="logout"
        iconPlacement="icon-after"
        (clickedButton)="onLogout()"
        [disabled]="loggingOut"
        data-testid="logout_button"
      ></art-button>
    </div>
  </div>
</div>
